import { FilterStore } from 'components/Filters/FilterStore'
import { TableSearchWithElastic } from 'components/Filters/TableSearchWithElastic'
import { PiForkKnife, PiGlobe, PiStorefront } from 'react-icons/pi'
import { dataTableSortingStoreRepo } from '../../DataTable/DataTableSorting/DataTableSortingStore'

/**
 * Restaurant/Chains header search: tri-mode Elasticsearch (menu / name / domain)
 * plus the relevancy-sort choreography — name searches sort by `relevancy`, all
 * other searches reset to chain `count`.
 *
 * Extracted from `ChainsTableComponent` (FIR-7728, step 2). Its props are a
 * subset of `<TableSearch>`'s, so it is assignable to the `<DECommonTable>`
 * `SearchComponent` seam: when Chains migrates onto `<TargetTable>` (step 3),
 * the Chains config sets `SearchComponent: ChainsTableSearch` and the shared
 * table renders this instead of the plain search. `searchPlaceholder` /
 * `className` are accepted for seam compatibility but unused (the elastic input
 * carries its own per-mode placeholders).
 */
export function ChainsTableSearch({
  filterStore,
  tableKey,
}: {
  filterStore: FilterStore
  tableKey?: string
  searchPlaceholder?: string
  className?: string
}) {
  const setSorting = dataTableSortingStoreRepo.getStore(tableKey ?? '')(
    (s) => s.setSorting
  )
  return (
    <TableSearchWithElastic
      filterStore={filterStore}
      historyKey="chains"
      options={[
        {
          label: 'Menu',
          searchKey: 'menu',
          searchPlaceholder: 'Search menus… e.g. chicken',
          elastic: true,
          autoSetRelevancySort: false,
          icon: PiForkKnife,
        },
        {
          label: 'Name',
          searchKey: 'chain_name',
          searchPlaceholder: 'Search chain names… e.g. Bella’s Bistro',
          elastic: true,
          autoSetRelevancySort: true,
          icon: PiStorefront,
        },
        {
          label: 'Domain',
          searchKey: 'domain_elastic',
          searchPlaceholder: 'Search domains… e.g. bellasbistro.com',
          elastic: false,
          autoSetRelevancySort: false,
          icon: PiGlobe,
        },
      ]}
      onSearchApplied={(option) => {
        if (option.autoSetRelevancySort) {
          // Name searches: set to relevancy sort
          setSorting([{ id: 'relevancy', desc: true }])
        } else {
          // All other searches (menu, domain): reset to chain count
          setSorting([{ id: 'count', desc: true }])
        }
      }}
    />
  )
}
